module.exports = __webpack_public_path__ + "img/taiping.1e0d979c.png";